import React, { Component } from 'react'
import Link from '../Link'
import styles from './Footer.css'

export default class Footer extends Component {
  render () {
    return (
      <div>
        <div className={styles.cont}>
          {this.props.links.map((item, k) => <Item key={k} {...item}/>)}
        </div>
        <div className={styles.copyright} dangerouslySetInnerHTML={{__html: this.props.copyright}}/>
      </div>
    )
  }
}

class Item extends Component {
  render () {
    return (
      <div className={styles.itemCont}>
        <div className={styles.item}>
          {
            this.props.title && (
              <div className={styles.title}>
                {this.props.title}
              </div>
            )
          }
          <div className={styles.body}>
            {this.props.images.map(item => <Image key={item.image} {...item}/>)}
          </div>
        </div>
      </div>
    )
  }
}

class Image extends Component {
  render () {
    return (
      <Link to={this.props.url} className={styles.col}>
        <img className={styles.image} src={this.props.image}/>
      </Link>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Rist/modules/Footer/index.js